import React from "react";

export interface AutomationsOverviewProps {
	workspaceId: string;
	session?: any;
	currentWorkspace?: any;
}

export const AutomationsOverview: React.FC<AutomationsOverviewProps> = ({
	workspaceId,
	session,
	currentWorkspace,
}) => {
	return (
		<div className="flex h-full flex-col items-center justify-center bg-background p-8 text-foreground">
			<h1 className="mb-2 font-bold text-2xl">Automations Overview</h1>
			<p className="text-muted-foreground">
				Workspace: <span className="font-mono">{workspaceId}</span>
			</p>
			<p className="mt-4 text-muted-foreground text-sm">
				Automation workflows overview would go here
			</p>
		</div>
	);
};